import { render, staticRenderFns } from "./SmsCarrierRestrictionInfo.vue?vue&type=template&id=f0a3180c&"
import script from "./SmsCarrierRestrictionInfo.vue?vue&type=script&lang=js&"
export * from "./SmsCarrierRestrictionInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports